module.exports = __webpack_public_path__ + "static/media/Beatriz Guerra.3c520736.png";